/**
 * Created by Owner on 2016/8/8.
 */
import {Component, Input, trigger, state, style, transition, animate} from '@angular/core';

@Component({
    selector: 'open-num-comp',
    template: `
        <div class="container" *ngIf="_openRecord.length!=0" [ngSwitch]="openType">
            <ion-row *ngSwitchCase="'big'">
                <ion-col class="num-item" *ngFor="let item of _openRecord"
                         [@flyInOut]="item.state"
                >
                    <div class="round1">{{item.num}}</div>
                </ion-col>
            </ion-row>
            <ion-row *ngSwitchCase="'sm'">
                <ion-col class="num-item sm-item" *ngFor="let item of _openRecord"
                         [@flyInOut]="item.state"
                >
                    <div class="round-sm">{{item.num}}</div>
                </ion-col>
            </ion-row>
            <div *ngSwitchDefault>
                <div class="num-item small-item" *ngFor="let item of _openRecord"
                     [@flyInOut]="item.state"
                >
                    <div class="round1">{{item.num}}</div>
                </div>
            </div>
        </div>
    `
    ,
    animations: [
        trigger('flyInOut', [
            state('inactive', style({
                opacity: 0,
                transform: 'scale(1)'
            })),
            state('active', style({
                opacity: 1,
                transform: 'scale(1.1)'
            })),
            transition('inactive => active', animate('100ms ease-in')),
        ])
    ]
})
export class OpenNumComponent {
    openType: string = "big";
    _openRecord: numRecord[] = [];
    @Input()
    set openRecord(nums: any) {
        // nums = ["01","01","01","01","01","01","01","01","01","01"];
        let record: any = [];
        nums.forEach((item, index) => {
            record.push({
                state: 'inactive',
                num: item
            })
        });
        this._openRecord = record;
        this.openType = record.length > 5 ? "" : "big";
        if (record.length == 7) {
            this.openType = "sm";
        }
        if (record.length > 0) {
            let time1: number = 0;
            let ant = setInterval(() => {
                let lg = record.length;
                if (time1 == lg) {
                    this.clear();
                    clearTimeout(ant);
                } else {
                    this._openRecord[time1]["state"] = 'active';
                    time1++;
                }
            }, 300);
        }
    }

    get openRecord() {
        return this._openRecord;
    }

    constructor() {
    }

    clear() {
        setTimeout(() => {
            this._openRecord = [];
        }, 2000)
    }
}

export class numRecord {
    num: number;
    state: string;
}



// WEBPACK FOOTER //
// ./src/component/openNum/openNum.ts